import { createContext } from 'react';
export const ErrorHandlerContext = createContext(null);
//# sourceMappingURL=error-handler.js.map